import * as yaml from 'js-yaml';

export interface YAMLPageConfig {
  page: {
    id: string;
    title: string;
    description: string;
    toolbar?: {
      breadcrumb?: any[];
      actions?: any[];
    };
    api?: {
      list: string;
      delete?: string;
    };
    components?: any[];
  };
}

export const loadYAMLPage = async (pageId: string): Promise<YAMLPageConfig | null> => {
  try {
    const response = await fetch(`/navigation/pages/${pageId}.yaml`);
    if (!response.ok) {
      console.error(`Failed to load YAML for page: ${pageId}`);
      return null;
    }
    const yamlText = await response.text();
    const config = yaml.load(yamlText) as YAMLPageConfig;
    return config;
  } catch (error) {
    console.error(`Error loading YAML page ${pageId}:`, error);
    return null;
  }
};
